import { useState, useEffect, useCallback } from 'react';
import { Breakpoints } from '@bitcoin-portal/bitcoincom-pkg-theme';

const defaultBreakpoint = Breakpoints.md;

const isClientSide = () => typeof window !== 'undefined';

export const useBreakpoint = (breakpoint = defaultBreakpoint) => {
  const [matches, setMatches] = useState(
    isClientSide() ? window.innerWidth >= breakpoint : false,
  );

  const changeHandler = useCallback(event => {
    if (event.matches) {
      setMatches(true);
    } else {
      setMatches(false);
    }
  }, []);

  useEffect(() => {
    const mediaQuery = `(min-width: ${breakpoint}px)`;
    const mediaQueryList = isClientSide()
      ? window.matchMedia(mediaQuery)
      : null;

    if (
      typeof mediaQueryList?.addEventListener === 'function' &&
      typeof mediaQueryList?.removeEventListener === 'function'
    ) {
      mediaQueryList.addEventListener('change', changeHandler);

      return () => {
        mediaQueryList.removeEventListener('change', changeHandler);
      };
    }

    return undefined;
  }, [breakpoint, changeHandler]);

  return matches;
};
